export const UMR = {
  ROPNER: "B085620L2002",
  GALLAGHER: "B1262FSM0017921",
  LIG: "B1586LIG2021LS89",
  RAP: "B1368M215170",
  AH: "B0999DUA12342021",
};
export default UMR;
